import React, {useEffect, useState} from 'react';
import Header from "../navigation/Header";
import {Link, useNavigate, useParams} from "react-router-dom";
import {Modal} from "react-bootstrap";
import {
    getPossibleChangesForAgreement,
    getStopAgreementStatus,
    stopAgreement,
    testyPay
} from "../../services/ProductRepository";
import {useError} from "../../hooks/useError";
import {fetchWithRetry} from "../../services/AxiosConfig";

function getAlertOnChange(status, positiveMsg, negativeMsg) {
    if(status) {
        return (
            <div className={"alert alert-primary"} role="alert">
                <p>{positiveMsg}</p>
            </div>
        );
    } else {
        return (
            <div className={"alert alert-danger"} role="alert">
                <p>{negativeMsg}</p>
            </div>
        );
    }
}

function getCurrentToken(tokens) {
    return tokens.find(item => item.currentPlan)
}

export function ManageSubscription() {

    const params = useParams();
    const [showModal, setShowModal] = useState(false);
    const [tokens, setTokens] = useState([]);
    const [stoppedStatus, setStoppedStatus] = useState(null);
    const  {setErrorMessage} = useError();
    const navigate = useNavigate();

    useEffect(() => {
        getPossibleChangesForAgreement(setErrorMessage).then(response => setTokens(response))
    }, []);

    return (
        <div>
            <Header/>

            <Modal show={showModal} onHide={() => setShowModal(false)} centered={true}>
                <Modal.Header>
                    <h4 className={"fw-bold"}>
                        Er du sikker på at du vil avslutte?
                    </h4>
                </Modal.Header>
                <Modal.Body>
                    <div data-testid={"modal-avslutt"}>
                        {
                           stoppedStatus != null ?
                               getAlertOnChange(stoppedStatus, "Planen din har blitt avsluttet", "Noe gikk galt")
                            : null
                        }
                        <p>
                            Dersom du avslutter, vil alle resterende betalinger som er
                            laget, bli gjennomført. Du vil ha tilgang til kurset helt til
                            neste periode hvor betalingen ikke blir trukket. Dersom du ønsker
                            å gjenopprette abonnementet, må du kjøpe kurset på nytt.
                        </p>
                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <button className={"btn btn-danger text-white"} data-testid={"avslutt-bekreft"} onClick={() => {
                        stopAgreement(setErrorMessage).then((agreementId) => {
                            fetchWithRetry(() => getStopAgreementStatus(agreementId, setErrorMessage), (response) => response === true, 20, 1000)
                                .then(result => {
                                    setStoppedStatus(true)
                                    setTimeout(() => {
                                        navigate("/hjem")
                                    }, 2000)
                                })
                                .catch(error => console.error(error))
                        });
                    }}>Avslutt mitt abonnement</button>
                </Modal.Footer>

            </Modal>

            <div className={"container p-5"}>
                <h3 className={"mb-3"}>Administrer din pakke</h3>



                {
                    tokens.map((token, idx) => (
                        <div className={"border rounded p-3 my-2"}>
                            <div className={"row"}>
                                <div className={"col"}>
                                    <h4 className={"text-muted"}>{token.tokenName}</h4>
                                    <h2>{token.price} NOK / måned</h2>
                                </div>
                                <div className={"col-3"}>
                                    {
                                        token.currentPlan ?
                                            <p className={"border rounded p-3 text-center"}>Du eier denne pakken</p>
                                            :
                                            <Link to={`bekreft/${getCurrentToken(tokens).tokenId}/${token.tokenId}`} data-testid={`bytt-abonnement-${token.tokenName}`} className={"btn btn-dark w-100"}>Bytt til denne pakken</Link>
                                    }

                                </div>
                            </div>
                        </div>
                    ))
                }


                <p className={"mt-3"}>Ønsker du heller å avslutte abonnementet fullstendig kan du gjøre det under eller i Vipps appen.</p>
                <button className={"btn btn-danger text-white"} onClick={() => setShowModal(true)} data-testid={"avslutt-abonnement"}>Avslutt abonnement</button>
            </div>
        </div>
    );

}